import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import P1 from "../../../../components/paragraph";
import ChartImage1 from '../../../../assets/img/landlord1.png'
import ChartImage2 from '../../../../assets/img/landlord2.png'
import ChartImage3 from '../../../../assets/img/landlord3.png'
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '-35px'}}>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 24}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <P1>
                                    <div className="GuidesContentSection__layout">
                                        <div className="ArticleMarkdown">

                                        <p>MOGUL Property Management Software provides landlords and property management companies a robust, AI driven solution to manage, rental listings, tenant screening, lease tracking, rent payments and maintenance requests while also providing management and tenants convenience, speed and security.</p>        
                                        </div>
                                    </div>
                                </P1>                   
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
